import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerConstants, LoggerData } from './Logger.model';
import { LoggerService } from './LoggerService.service';
import { Router } from '@angular/router';
import { decode, extractChunkInfo } from './cpq-stack-trace-helper';

@Injectable()
export class CpqGlobalErrorHandler implements ErrorHandler {
  public logData: LoggerData;
  public errorMessage: string;
  public label: string
  public title: string;

  constructor(private loggerService: LoggerService, private router: Router) {
  }
  async handleError(error: Error | HttpErrorResponse) {
    const currentUrl = this.router?.url ?? window.location.pathname;
    console.error(`[URL: ${currentUrl}]`, error);
    if (error instanceof HttpErrorResponse) {
      // Server Error
      if (error.status < 500) {
        return;
      }
      this.errorMessage = error.message;
      this.label = LoggerConstants.ServerError;
      this.title = error.url;
    } else {
      // Client Error
      if (!navigator.onLine) {
        this.errorMessage = 'No Internet Connection';
      } else {
        const originalMessage = error.stack ? error.stack.trim() : error.message;
        let info = extractChunkInfo(originalMessage);
        if (info) {
          const msg = await decode(info.chunkName, info.line, info.column);
          if (msg && msg.source && msg.source !== info.chunkName) {
            this.errorMessage = `[URL: ${currentUrl}]\n[Component: ${msg.source} : ${msg.line} - ${msg.column}]\n[Error: ${error.message}]`;
          } else {
            this.errorMessage = `[URL: ${currentUrl}] [Source map decoding failed] ${error.stack || error.message}`;
          }
        } else {
          this.errorMessage = `[URL: ${currentUrl}] [Extract chunk info was not successful] ${error.stack || error.message}`;
        }
        this.label = LoggerConstants.ClientError;
        this.title = LoggerConstants.ClientTitle;
      }
    }
    this.logData = {
      level: LoggerConstants.Fatal,
      labels: this.label,
      description: this.errorMessage,
      title: this.title
    };
    this.loggerService.save(this.logData).subscribe();
  }

}
